import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export default class AuthRoute extends RouteBase {
  prefix = 'auth.'

  login() {
    return this.ziggyRoute('login')
  }

  logout() {
    return this.ziggyRoute('logout')
  }

  register() {
    return this.ziggyRoute('register')
  }

  passwordResetRequest() {
    return this.ziggyRoute('password.email')
  }

  passwordResetUpdate() {
    return this.ziggyRoute('password.update')
  }

  phoneVerifyPage() {
    return this.ziggyRoute('phone_verify_page')
  }

  phoneVerifyPageVerification() {
    return this.ziggyRoute('phone_verify_page_verification')
  }

  resendVerificationSmsCode() {
    return this.ziggyRoute('resend_verification_sms_code')
  }

  phoneVerify() {
    return this.ziggyRoute('phone_verify')
  }

  passwordReset() {
    return this.ziggyRoute('password.request')
  }

  resendEmailVerification() {
    return this.ziggyRoute('verification.resend')
  }

  //

  // registerPhoneVerify() {
  //   return this.ziggyRoute('phone_verify_page_verification')
  // }

  // passwordRequest() {
  //   return this.ziggyRoute('password.request')
  // }

  // passwordEmail() {
  //   return this.ziggyRoute('password.email')
  // }

  // passwordUpdate() {
  //   return this.ziggyRoute('password.update')
  // }


}

